module.exports = __webpack_public_path__ + "img/icon-doc.a2e0e143.svg";